import { Chip as MUIChip } from '@mui/material';

/**
 * Pass-through alias for MUI's Chip — byte-for-byte identical to
 * `material/components/Chip`, which is the same alias in the material
 * wrapper collection. All MUI Chip props pass through unchanged; the two
 * files are interchangeable duplicates.
 */
const Chip = props => <MUIChip {...props} />;

export default Chip;
